<template>
  <div class="swiper-main">
    <div class="swiper-container3 swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in adventureList" :key="item.id" @click="swiperEvent(item.id)">
         <div class="swiper-slide-content">
            <img loading="lazy"  :src="item.img" alt="" :class="type == 1 ? 'swiper-slide-img' : 'swiper-slide-img1'">
            <div class="swiper-all-content" v-show="type != 1">
              <div class="swiper-slide-title">{{item.title}}</div>
              <div class="swiper-slide-desc">{{item.desc}}</div>
            </div>
         </div>
        </div>
      </div>
      <div class="next common"><img loading="lazy"  :src="left" alt=""></div>
      <div class="prev common"><img loading="lazy"  :src="right" alt=""></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import  swiperData  from '/js/experience/traffic/swiper.js';
import left from '/static/img/newProductDetils/left1.png'
import right from '/static/img/newProductDetils/right1.png'
export default {
  props:{
    type:Number,
    swiperList:Array,
  },
  data() {
    return {
      swiper: null, // 用于存储 Swiper 实例
      adventureList:[],
      left:left,
      right:right,
      viewportWidth:0
    };
  },
  created() {
    if(this.type == 1){
      this.adventureList = this.swiperList
    }else{
      this.adventureList = swiperData.swiperList
    }
  },
  watch:{
    swiperList(newVal){
      if(this.type == 1){
        if(newVal.length > 0){
          this.adventureList = newVal
        }
      }
    },
    deep:true,
    immediate:true
  },
  mounted() {
    // 初始化 Swiper
    this.swiper = new Swiper('.swiper-container3', {
      slidesPerView: 3,
      spaceBetween: 26,
      // keyboardControl: true,
      nextButton: '.prev',
      prevButton: '.next',
      centeredSlides: true, // 中间的幻灯片居中
      // 其他Swiper3参数...
      // loop: true, // 循环模式
      autoplay: 3000, // 自动播放（ms）
      loop:this.type == 1 ? false : true,
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true,
      // },

    });
  },
  methods: {
    // goToNextSlide() {
    //   this.swiper.slidePrev(); // 回退到上一个幻灯片
    // },
    // goToPrevSlide() {
    //   this.swiper.slideNext(); // 切换到下一个幻灯片
    // },
    swiperEvent(id){
      if(this.type == 1){
        this.$emit('childSlideEvent',id)
      }
    },
    // swiperEvent(id){
    //   if(id == 1 || id == 2){
    //     this.$router.push({
    //       path:'/productDetails',
    //       query:{id:1}
    //     })
    //   }else if(id == 3 || id == 4){
    //     this.$router.push({
    //       path:'/productDetails',
    //       query:{id:2}
    //     })
    //   }else if(id == 5 || id == 6){
    //     this.$router.push({
    //       path:'/productDetails',
    //       query:{id:3}
    //     })
    //   }
    // },
  }
};
</script>

<style scoped lang="scss">
@import '../../../../style/pc/productContent/swiper/swiper.scss';
</style>
